import { render } from "./DashboardTopbar.vue?vue&type=template&id=1ff44dc9&scoped=true&ts=true"
import script from "./DashboardTopbar.vue?vue&type=script&lang=ts"
export * from "./DashboardTopbar.vue?vue&type=script&lang=ts"

import "./DashboardTopbar.vue?vue&type=style&index=0&id=1ff44dc9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff44dc9"]])

export default __exports__